/* slider bindings*/
var applyFancyboxPictures = function () {
    $.each($("a.open_mediabox_window"), function () {
        $(this).find('img').parent().attr("data-fancybox-group", "fancy-productImageSlider").addClass("fancy-productImageSlider");
    });
};

// init fancybox first time
applyFancyboxPictures();
$(document).on('translatorContentReloaded', function (e) {
    applyFancyboxPictures();
});